const titleList = [{
    label: "文件名称",
    prop: "fileName",
    width: "120",
},
{
    label: "创建时间",
    prop: "startTime",
    width: "150"
},
{
    label: "任务状态",
    prop: "status",
    width: '110',
    align: "center"
},
{
    label: "完成时间",
    prop: "endTime",
    width: "150"
},
{
    label: "状态信息",
    prop: "remark",
    width: '160',
    align: 'center'
},
]






export {
    titleList,
}